import { IStatusIndicator, Statuses } from "src/@types/deals";
import { ReactComponent as PersonAddIcon } from "src/assets/icons/person-add.svg";
import { ReactComponent as HourglassIcon } from "src/assets/icons/hourglass.svg";
import { ReactComponent as SuccessIcon } from "src/assets/icons/success.svg";
import { ReactComponent as PauseIcon } from "src/assets/icons/pause.svg";
import { ReactComponent as CancelIcon } from "src/assets/icons/cancel.svg";
import { dealStatusesTrns } from "./trns";

export const STATUSES: Record<Statuses, IStatusIndicator> = {
  newRequest: {
    icon: PersonAddIcon,
    className: "text-purple-base fill-svg-purple-base",
    title: { i18nKey: dealStatusesTrns.newRequest },
  },
  pending: {
    icon: HourglassIcon,
    className: "text-green-base fill-svg-green-base",
    title: { i18nKey: dealStatusesTrns.pending },
  },
  inProgress: {
    icon: HourglassIcon,
    className: "text-purple-base fill-svg-purple-base",
    title: { i18nKey: dealStatusesTrns.inProgress },
  },
  done: {
    icon: SuccessIcon,
    className: "text-green-base fill-svg-green-base",
    title: { i18nKey: dealStatusesTrns.done },
  },
  suspended: {
    icon: PauseIcon,
    className: "text-gray-base fill-svg-gray-base",
    title: { i18nKey: dealStatusesTrns.suspended },
  },
  canceled: {
    icon: CancelIcon,
    className: "text-red-base fill-svg-red-base",
    title: { i18nKey: dealStatusesTrns.canceled },
  },
};
